(function() {
  const prefix = "gnmn";

  const now = new Date();
  const month = now.toLocaleString('default', { month: 'short' }).toLowerCase();
  const year = now.getFullYear();

  const code = `${prefix}${month}${year}`;

  // Target Gunamuna footer text
  const target = document.querySelector('.footer__copyright.text--xsmall.text--subdued');

  if (target) {
    const span = document.createElement("span");
    span.textContent = " | " + code;

    // Ensure styling matches perfectly
    span.style.font = "inherit";
    span.style.letterSpacing = "inherit";
    span.style.color = "inherit";

    target.appendChild(span);
  }
})();